<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <v-row>
          <!--<v-col cols="12">-->
          <!--  <v-alert class="bg-info mb-0" dense>-->
          <!--    <div class="body-1 font-weight-medium">Informasi Kondisi Kelompok !</div>-->
          <!--    <div class="body-2">-->
          <!--      <span class="font-weight-medium">Reguler</span>: kondisi kelompok sebagaimana aturan model pendampingan-->
          <!--      yang berlaku saat ini, dimana satu kelompok minimum terdiri dari-->
          <!--      <span class="font-weight-medium">2 model/kategori</span> pendampingan-->
          <!--    </div>-->
          <!--    <div class="body-2">-->
          <!--      <span class="font-weight-medium">Khusus</span>: kondisi kelompok karena adanya alasan khusus/mendesak,-->
          <!--      maka diperbolehkan dalam suatu kelompok hanya terdiri dari-->
          <!--      <span class="font-weight-medium">1 model/kategori</span> pendampingan-->
          <!--    </div>-->
          <!--  </v-alert>-->
          <!--</v-col>-->
          <v-col cols="12">
            <base-form-generator :schema="schema" v-model="form" />
          </v-col>
          <v-col cols="12">
            <div>
              <h4>Pilih Sekolah</h4>
              <v-alert class="my-1" color="blue" text dense>
                <v-row>
                  <v-col class="grow my-auto">
                    <div class="black--text">
                      Silakan pilih
                      <b> (maksimal {{ limit[jenis === 'kp_pa' ? jenis : 'default'][1] }}) </b>
                      sekolah yang ingin dijadikan Anggota Kelompok
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-btn class="success" depressed @click="onPilihSekolah">
                      <v-icon left>mdi-hospital-building</v-icon>
                      Pilih Sekolah
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </div>
            <template v-if="sekolah.length">
              <div class="mt-5 mb-2 font-weight-medium subtitle-1">
                <span class="blue--text">{{ sekolah.length }}</span> Sekolah Terpilih
              </div>
              <v-spacer />
              <v-list>
                <div v-for="(item, i) in sekolah" :key="item.sekolah_id">
                  <v-divider v-if="i !== 0" class="my-3" />
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue">
                      <v-icon dark>mdi-hospital-building</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <v-row>
                        <v-col cols="12" lg="7">
                          <div class="blue--text font-weight-medium body-1">
                            {{
                              $getDeepObj(item, 'nama') ||
                                $getDeepObj(item, 'sekolah.data.nama') ||
                                $getDeepObj(item, 'sekolah.nama') ||
                                '-'
                            }}
                          </div>
                          <div class="black--text body-2">
                            <span class="font-weight-medium">NPSN: </span>
                            {{
                              $getDeepObj(item, 'npsn') ||
                                $getDeepObj(item, 'sekolah.data.sekolah_id') ||
                                $getDeepObj(item, 'sekolah.sekolah_id') ||
                                '-'
                            }}
                          </div>
                          <div class="black--text body-2">
                            <span class="font-weight-medium">Alamat: </span>
                            {{
                              $getDeepObj(item, 'alamat') ||
                                $getDeepObj(item, 'sekolah.data.alamat') ||
                                $getDeepObj(item, 'sekolah.alamat') ||
                                '-'
                            }}
                          </div>
                        </v-col>
                        <v-col v-if="false" cols="12" lg="5">
                          <div class="body-2 grey--text">Kategori</div>
                          <v-icon :color="kategoris[item.k_kp_kategori_psp]" class="mr-0" size="30">
                            mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action-text>
                      <v-btn icon color="red" @click="onDelete(i)"><v-icon>mdi-close-circle</v-icon></v-btn>
                    </v-list-item-action-text>
                  </v-list-item>
                </div>
              </v-list>
            </template>
          </v-col>
        </v-row>
        <v-spacer />
      </v-container>
    </v-card>
    <sumber
      ref="kandidat"
      title="Pilih Sekolah"
      :api="`${jenis === 'kp_pa' ? 'diklatPa' : 'diklatDkp'}/getKandidat`"
      :custom-params="getCustomParams"
    />
  </div>
</template>
<script>
import Sumber from './ListSekolahKpPa';
import BaseFormGenerator from '@components/base/BaseFormGenerator';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    jenis: {
      type: String,
      default: 'kp',
    },
    gelombang: {
      type: [Number, String],
      defualt: 2,
    },
    tahun_ke: {
      type: [Number, String],
      defualt: 1,
    },
  },
  components: { BaseFormGenerator, Sumber },
  data() {
    return {
      form: { is_khusus: 0 },
      sekolah: [],
      limit: {
        kp_pa: [0, 12],
        default: [1, 20],
      },
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },
  computed: {
    schema() {
      return [
        {
          type: 'VTextField',
          name: 'nama',
          label: `Nama Kelompok Pendampingan ${this.jenis === 'kp' ? 'KP' : 'PA'}`,
          labelColor: 'secondary',
          hint: 'wajib diisi',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
        },
      ];
    },

    getCustomParams() {
      if (this.jenis === 'kp_pa') {
        return { gelombang: this.gelombang };
      }

      return {};
    },
  },
  methods: {
    initForm(value) {
      if (!value) return;
      this.$set(this.form, 'nama', this.$getDeepObj(value, 'nama') || '');
      this.$set(this.form, 'is_khusus', this.$getDeepObj(value, 'is_khusus') || 0);
      this.sekolah =
        this.$getDeepObj(value, `psp_${this.jenis}_sekolahs.data`) ||
        this.$getDeepObj(value, `psp_${this.jenis}_sekolahs`) ||
        [];
    },

    reset() {
      this.$set(this, 'form', { is_khusus: 0 });
      this.$set(this, 'sekolah', []);
    },

    getValue() {
      let form = this.form;
      let sekolah = [];
      this.sekolah.forEach((item) => {
        sekolah.push(item.sekolah_id);
      });

      form['sekolah'] = sekolah;
      form['gelombang'] = this.gelombang;
      form['tahun_ke'] = this.tahun_ke;

      return {
        form: form,
      };
    },

    onPilihSekolah() {
      const sekolah = [...this.sekolah].map((key) => key.sekolah_id);
      const fields = [
        {
          key: 'nama',
          icon: 'mdi-hospital-building',
          title: '',
          list: [
            {
              key: 'nama',
              class: 'body-1 blue--text',
            },
            {
              key: 'npsn',
              label: 'NPSN: ',
              class: 'body-2 black--text font-weight-medium',
            },
            {
              key: 'alamat',
              class: 'black--text',
            },
          ],
        },
      ];

      this.$refs.kandidat.open(fields, sekolah).then((resp) => {
        resp.forEach((item) => {
          this.sekolah.push(item);
        });
      });
    },

    validate() {
      let status = true;
      if (
        this.sekolah.length < Number(this.limit[this.jenis === 'kp_pa' ? this.jenis : 'default'][0]) ||
        this.sekolah.length > Number(this.limit[this.jenis === 'kp_pa' ? this.jenis : 'default'][1])
      ) {
        this.$error(
          `Sekolah hanya bisa dipilih ${
            +this.limit[this.jenis === 'kp_pa' ? this.jenis : 'default'][0] > 0
              ? `minimal ${Number(this.limit[this.jenis === 'kp_pa' ? this.jenis : 'default'][0])} dan `
              : ''
          } maksimal ${Number(this.limit[this.jenis === 'kp_pa' ? this.jenis : 'default'][1])}`
        );
        status = false;
      }
      return status;
    },

    onDelete(index) {
      this.sekolah.splice(index, 1);
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
